import './styles.scss';

const ProductSideBar = ({ items }) => {
    const onSection = el => {
        const clickedTitle = items.find(item => item === el);
        window.location.href = `#${clickedTitle}`;
    };

    return (
        <div className="products-sidebar">
            {items.map(el => (
                <div key={el} className="products-sidebar__item" onClick={() => onSection(el)}>
                    <p className="button-text">{el.toUpperCase()}</p>
                </div>
            ))}
        </div>
    );
};

export default ProductSideBar;
